// assets/dh-common.js
// Shared Design Huddle helpers used across home / product / editor pages.
// Loaded globally in theme.liquid right after the DH SDK lib, so it is
// available (as `window.DH`) to every other DH script.
(function () {
  const DH = (window.DH = window.DH || {});

  // ---------- SDK configuration ----------
  DH.CONFIG = {
    client_id: "f4fla79upm8lohatj2ns",
    domain: "weprint.designhuddle.com"
  };

  // Mode: 'visitor' for browse pages, 'guest' for editor / customize flows.
  DH.configure = function (mode) {
    if (!window.DSHDLib || typeof DSHDLib.configure !== "function") return;
    DSHDLib.configure(Object.assign(
      {},
      DH.CONFIG,
      mode === "guest" ? { guest: true } : { visitor: true }
    ));
  };

  // ---------- localStorage hash readers ----------
  // Safely read + validate a stringified hash from localStorage.
  // Strips JSON quoting and rejects obvious empties.
  DH.readHash = function (key) {
    const raw = localStorage.getItem(key);
    if (!raw) return null;
    let val = raw;
    try {
      const parsed = JSON.parse(raw);
      if (typeof parsed === "string") val = parsed;
    } catch (_) {}
    val = String(val).trim().replace(/^['"]+|['"]+$/g, "");
    if (!val || /^(null|undefined|\{\}|\[\])$/i.test(val) || val.length < 4) {
      return null;
    }
    return val;
  };

  // Prefer the guest-context hash (set when the user clicks Customize) and
  // fall back to the visitor hash (set by the homepage upload). Either
  // means "the user has uploaded a logo."
  DH.readTcoHash = function () {
    return (
      DH.readHash("dh_tco_hash_guest") ||
      DH.readHash("dh_tco_hash_visitor")
    );
  };

  DH.hasUploadedLogo = function () {
    return !!(DH.readTcoHash() || localStorage.getItem("dh_logo_url"));
  };

  // ---------- Apparel geometry + background images ----------
  DH.APPAREL_GEOMETRY = {
    hat: {
      bg:     { w: 480 },
      zone:   { w: 240, h: 125 },
      offset: { x: 120, y: 192 }
    },
    hoodie: {
      bg:     { h: 480 },
      zone:   { w: 168, h: 120 },
      offset: { x: 154, y: 106 }
    }
  };

  const ASSET_BASE_DEFAULT =
    "https://weprintdemo.designhuddle.com/cdn/shop/t/2/assets/";

  DH.isApparelType = function (h) {
    const s = String(h || "").toLowerCase();
    return s === "hat" || s === "hoodie";
  };

  // hasHash = true  → "-blank.png"   (clean canvas to compose a design on)
  // hasHash = false → "-default.png" (canvas with built-in placeholder logo)
  DH.resolveApparelBg = function (type, color, hasHash) {
    const base = window.DH_ASSET_BASE || ASSET_BASE_DEFAULT;
    const safeType = (type || "").toLowerCase();
    const safeColor = (color || "white").toLowerCase();
    const mode = hasHash ? "blank" : "default";
    return `${base}${safeType}-${safeColor}-${mode}.png`;
  };

  // Build the full VTP / Editor.insert apparel params object for hat/hoodie.
  DH.buildApparelParams = function (type, color, hasHash) {
    const g = DH.APPAREL_GEOMETRY[String(type || "").toLowerCase()];
    if (!g) return null;
    const params = {
      product_image_url: DH.resolveApparelBg(type, color, !!hasHash),
      product_image_canvas_zone_dimensions: `${g.zone.w}x${g.zone.h}`,
      product_image_canvas_zone_offset: `${g.offset.x}x${g.offset.y}`
    };
    if (g.bg.w) params.product_image_width = g.bg.w;
    if (g.bg.h) params.product_image_height = g.bg.h;
    return params;
  };

  // ---------- Preview loading state ----------
  // Find the preview wrap for an img. The wrap is the element styled while
  // the image is loading. Product page: declared in the markup; homepage:
  // created dynamically around the img.
  DH.getWrap = function (img) {
    return img.closest("[data-dh-preview-wrap]") || img.parentElement;
  };

  // Toggle the loading state for a preview image. Handles both DOM layouts:
  //   product page: spinner lives inside [data-dh-preview-wrap]
  //   homepage:     spinner is a sibling of the wrap inside .media (the
  //                 wrap was created at runtime after the spinner was rendered)
  DH.setImgLoading = function (img, on) {
    const wrap = DH.getWrap(img);
    if (!wrap) return;
    wrap.classList.toggle("is-loading", !!on);
    wrap.classList.toggle("is-loaded", !on);
    img.classList.toggle("is-loading", !!on);
    img.classList.toggle("is-loaded", !on);

    const spinner =
      wrap.querySelector(".loading__spinner") ||
      wrap.parentElement?.querySelector(":scope > .loading__spinner");
    if (spinner) spinner.classList.toggle("hidden", !on);
  };

  // Compute a DPR-aware target width to request from the VTP API.
  DH.getPreviewWidth = function (img) {
    const cssW = Math.ceil(img.getBoundingClientRect().width || 800);
    const dpr  = Math.max(1, Math.min(2, window.devicePixelRatio || 1));
    return Math.min(1600, Math.max(400, Math.ceil(cssW * dpr)));
  };
})();
